import { render, staticRenderFns } from "./Detailppbkl.vue?vue&type=template&id=75dd8983&scoped=true"
import script from "./Detailppbkl.vue?vue&type=script&lang=js"
export * from "./Detailppbkl.vue?vue&type=script&lang=js"
import style0 from "./Detailppbkl.vue?vue&type=style&index=0&id=75dd8983&prod&lang=scss"
import style1 from "./Detailppbkl.vue?vue&type=style&index=1&id=75dd8983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dd8983",
  null
  
)

export default component.exports